import { ApiResource } from '@/core/models/api-resource.interface';
import { JobFunction } from '@/core/models/job-function.interface';
import { LocationQuery } from 'vue-router';

const JOB_FUNCTION_INCLUDES = ['jobFunctionCategory', 'escoStatus', 'externalSourceMappings'];

export class JobFunctionService {
   async getJobFunctions(query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<JobFunction>>>(`/job-functions`, {
         params: { ...query, include: JOB_FUNCTION_INCLUDES.join(',') },
      });
      return response.data;
   }

   async getJobFunction() {
      throw Error('Method not implemented');
   }

   async postJobFunction(jobFunction: JobFunction) {
      const response = await http.post<{ data: JobFunction }>(`/job-functions`, jobFunction);
      return response.data;
   }

   async putJobFunction(jobFunction: JobFunction) {
      const response = await http.put<{ data: JobFunction }>(`/job-functions/${jobFunction.id}`, jobFunction);
      return response.data;
   }

   async deleteJobFunction(jobFunctionId: number) {
      await http.delete(`/job-functions/${jobFunctionId}`);
   }
}
